import { Injectable } from '@angular/core';
import { MapSettings } from 'app/models/settings/map-settings';
import { ErrorHandlerService } from 'app/services/error-handler.service';
import { MapsService } from 'app/services/map.service';
import { BehaviorSubject, Observable } from 'rxjs';

// General purpose of a store
// create a client side in-memory database for the application data
// put that client-side in-memory database inside a centralized service that we will call a Store
// ensure that the centralized service owns the data, by either ensuring its encapsulation or exposing it as immutable
// this centralized service will have reactive properties, we can subscribe to it to get notified when the Model data changes

// the map store is providing key map state information across maps.
// there is no map service to be incapsulated as this data at the moment is not stored in the database
@Injectable()
export class MapsStore {

   private _userMapSettings: BehaviorSubject<MapSettings> = new BehaviorSubject<MapSettings>(null);
   public userMapSettings$: Observable<MapSettings> = this._userMapSettings.asObservable();

    /// Maps Visibility
   public isCallersMapHidden: boolean = false;
   public isCallPointsMapHidden: boolean = false;
   public isScheduleMapHidden: boolean = false;
   // setting for maunal or auto zoom for all maps
   public isMapAutoZoom: boolean;

   // is map black and white
   public isBlackAndWhite: boolean;

   // alan needs to set a property to turn off map marker optimisation
   public OptimiseMapMarkers: boolean = true;

   // use map clustering
   public useMapClusterPoints: boolean;

   public useDirectRoutes:boolean;
   public useCallerDotIcon:boolean;
   public useVisitDotIcon:boolean;
   public showFrequency:boolean;

   // different image paths for map clustering
   public clusterMarkerImagePathOrginal: string = 'assets/icons/clustermarkers/orginals/m';
   public clusterMarkerImagePathPurple: string = 'assets/icons/clustermarkers/purple/m';
   public clusterMarkerImagePathGreen: string = 'assets/icons/clustermarkers/green/m';

   // using the style from https://snazzymaps.com/style/15/subtle-grayscale
   public customMapStyle:any = [ { 'featureType': 'all', 'elementType': 'all', 'stylers': [ { 'saturation': '-70' } ] },
   {  'featureType': 'poi', 'elementType': 'all', 'stylers': [  { 'visibility': 'off' } ] } ]

   // lat long of the  map when theuser is in manual mode
   // format is { lat: 51.491378, lng: -0.195999 }
   public manualMapCenter :any;
   public manualMapZoom :any;

   // The current maps bounds
   public mapBounds: any;

   constructor(private _mapService: MapsService, private _errorHandler: ErrorHandlerService) {
    this._userMapSettings.next(null);
   }

    initialiseModel(newMapSetting: MapSettings){
        if (newMapSetting == null) return;
        this.isMapAutoZoom = newMapSetting.autoZoom;
        this.isBlackAndWhite = newMapSetting.blackAndWhite;
        this.useMapClusterPoints = newMapSetting.clusterPoints;
        this.useDirectRoutes = newMapSetting.directRoutes;
        this.useCallerDotIcon = newMapSetting.callerDotIcon;
        this.useVisitDotIcon = newMapSetting.visitDotIcon;
        this.showFrequency = newMapSetting.frequency;
    }

   public getUserMapSettings() {
      this._mapService.getUserMapSettings()
      .subscribe((settings: MapSettings) => {
        this.initialiseModel(settings);
        this._userMapSettings.next(settings);
      },
      (error) => {
         this._errorHandler.handleError(error);
      });
   }

    public updateUserMapSettings(settings: MapSettings) {
      this._mapService.updateUserMapSettings(settings)
       .subscribe((data: any) => {
         this.getUserMapSettings();
      },
      (error) => {
         this._errorHandler.handleError(error);
      });
   }

   public loadUserMapSettings() {
      this.getUserMapSettings();
   }
}
